<template>
  <section
    class="search-bar"
    :class="{
      'not-home': !isHome,
      'is-personal': isPersonal,
      'show-suggestion': showSuggestion,
    }"
  >
    <img :src="logoPath" />
    <div class="menu" v-if="isPersonal">
      <h1>个人中心</h1>
      <ul>
        <li v-for="item in menu" :key="item.path">
          <router-link :to="item.path" :class="{ active: isActive(item.path) }">
            {{ item.name }}
          </router-link>
        </li>
      </ul>
    </div>
    <div class="search-row" v-else>
      <el-input
        v-model="searchValue"
        placeholder="请输入关键词，如：计算机"
        class="search-input"
        @keyup.enter.native="doSearch"
      >
        <el-select slot="prepend" v-model="selectValue" @change="changeSelection">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button slot="append" @click="doSearch">
          <img :src="searchIcon" />
        </el-button>
      </el-input>
      <!-- <router-link class="search-link" to="/search">高级检索</router-link> -->
    </div>
  </section>
</template>

<script>
export default {
  name: 'SearchBar',
  components: {},
  props: {},
  data() {
    return {
      searchIcon: require('/public/static/search.png'),
      searchValue: '',
      options: [],
      selectValue: '',
      menu: [
        { name: '我的工作台 >', path: '/MyWorkbench' },
        { name: '我的书单 >', path: '/MyBookList' },
        { name: '机构关联 >', path: '/MyRelation' },
        { name: '修改密码 >', path: '/MyPassword' },
        { name: '个人资料 >', path: '/MyProfile' },
      ],
      showSuggestion: false,
    }
  },
  computed: {
    isHome() {
      return this.$route.path === '/home'
    },
    logoPath() {
      if (this.isHome) return require('/public/static/logo_blue.png')
      return require('/public/static/logo_white.png')
    },
    isPersonal() {
      const isPersonal = this.$route.meta.isPersonal
      return isPersonal
    },
  },
  watch: {
    '$route.query.type'(type) {
      if (type === 'search') return false
      this.searchValue = ''
      if (this.options.length) this.selectValue = this.options[0].value
    },
  },
  methods: {
    async getSearchOptions() {
      const res = await this.$http.post(
        '/api/v1/datasearch/multi_db_book_search?refresharea=searchactions'
      )
      const options = this.lodash.get(res, 'returnvalue.searchactions[0].options', [])
      this.options = options
      if (options.length) this.selectValue = options[0].value
    },
    setShowSuggestion() {
      const showSuggestion = localStorage.getItem('showSuggestion') || 'false'
      this.showSuggestion = JSON.parse(showSuggestion)
    },
    changeSelection(val) {
      this.selectValue = val
    },
    doSearch() {
      let value = this.searchValue.trim()
      let searchObj = {
        word: value,
        name: value,
        title: '自定义条件',
        fieldname: this.selectValue,
        logicalop: 'and',
        relationop: 'like',
      }
      const searchFilter = {
        classify: [],
        top: [searchObj],
        left: [],
        search: [],
      }
      sessionStorage.setItem('searchFilter', JSON.stringify(searchFilter))
      if (this.$route.name === 'BookList') {
        this.$bus.$emit('refreshBookList')
      } else {
        this.$router.push({
          path: '/BookList',
          query: { type: 'search' },
        })
      }
    },
    isActive(path) {
      if (this.$route.path === '/MyBookListDetail') {
        return path === '/MyBookList'
      }
      return path === this.$route.path
    },
  },
  mounted() {
    this.setShowSuggestion()
    this.getSearchOptions()
  },
}
</script>

<style lang="scss" scoped>
section {
  height: 240px;
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 120px;
  &.show-suggestion {
    margin-top: 60px;
  }
  &.not-home {
    margin-top: 0;
    background-image: url('../../public/static/banner.png');
    .search-link {
      color: #fff;
    }
  }
  &.is-personal {
    padding: 37px 0;
    justify-content: space-between;
  }
}
.search-row {
  margin-top: 30px;
  display: flex;
  align-items: center;
  .search-link {
    margin-left: 15px;
    color: #333;
    font-size: 16px;
    text-decoration: none;
  }
}
.search-input {
  width: 580px;
  height: 48px;
  box-shadow: -1px 0px 7.68px 0.04px rgba(0, 131, 235, 0.2);
  overflow: hidden;
  /deep/ input {
    height: inherit;
    border: 0;
    border-radius: 0;
    font-size: 16px;
    color: #333;
    padding: 0 10px;
  }
  /deep/ .el-input-group__append {
    background-color: #fff;
    border: 0;
    border-radius: 0;
    padding: 0 10px;
  }
  /deep/ .el-input-group__prepend {
    width: 140px;
    background-color: #fff;
    border: 0;
    border-radius: 0;
    padding: 0;
    .el-input__inner {
      color: #333;
    }
  }
  /deep/ .el-select {
    margin: 0;
    height: 100%;
    input,
    input:hover {
      color: #333;
    }
    // 为了修复选择框在IE中高度不足的问题：
    .el-input--suffix {
      height: 100%;
    }
    .el-input__suffix-inner {
      border-right: 1px solid $mainColor;
      padding-right: 10px;
      i {
        color: #333;
        font-size: 16px;
      }
    }
  }
}
.menu {
  height: 100px;
  width: 1300px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.4),
    rgba(255, 255, 255, 0)
  );
  h1 {
    font-size: 22px;
    padding: 20px 40px;
    background-color: $mainColor;
    color: #fff;
  }
  ul {
    width: 460px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px 0;
    li {
      width: 33.3%;
      list-style: none;
      a {
        font-size: 16px;
        color: #fff;
      }
      a.active,
      a:hover {
        color: $mainColor;
      }
    }
  }
}

.search-link:hover {
  text-decoration: underline;
}
</style>
